<script setup>
  import { reactive, toRefs, watch, computed } from 'vue'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'

  let props = defineProps({
    termVisible: Boolean,
    termData: Array,
    libId: Number,
  })

  const store = useStore()
  const enterpriseGlobalId = computed(() => store.state.comm.enterpriseGlobalId)

  const languageInfoList = computed(() => {
    return store.state.user.languageInfoList
  })

  let emits = defineEmits(['update:termVisible', 'updateDefaultTerm'])

  const state = reactive({
    step: 1,
    description: '',
    libraryId: '',
    activeKey: '1',
  })

  const filterData = computed(() => {
    let list = props.termData || []
    return list.filter((item) => {
      return item.libType == state.activeKey
    })
  })

  const closeFunc = () => {
    emits('update:termVisible', false)
  }

  const confirm = () => {
    if (!state.libraryId) {
      return message.warning('请选择库')
    }
    emits('updateDefaultTerm', state.libraryId)
    closeFunc()
  }

  const checkFunc = (libraryId) => {
    const url =
      window.config.termCorpus +
      `/index?from=pe&libraryType=1&item=1&libraryId=${
        libraryId || ''
      }&enterpriseId=${enterpriseGlobalId.value}`
    window.open(url, '_termcorpus')
  }

  const languageText = (item) => {
    let stext = ''
    let tText = ''
    // debugger
    languageInfoList.value.some((citem) => {
      if (item.sourceLangId == citem.languageId) {
        stext = citem.languageShortName
      }
      if (item.targetLangId == citem.languageId) {
        tText = citem.languageShortName
      }
    })
    return `${stext}-${tText}`
  }

  watch(
    () => props.termVisible,
    (n) => {
      if (n) {
        state.libraryId = props.libId
      } else {
        state.libraryId = ''
      }
    }
  )

  const { libraryId } = toRefs(state)
</script>

<template>
  <a-modal
    :width="560"
    :visible="termVisible"
    :footer="null"
    :bodyStyle="{
      padding: 0,
    }"
    title="选择术语库"
    class="term-list-modal"
    @cancel="closeFunc"
    centered
  >
    <div class="padding-lr-20">
      <a-tabs v-model:activeKey="state.activeKey">
        <a-tab-pane key="1" tab="我创建的"></a-tab-pane>
        <a-tab-pane
          key="2"
          tab="企业协作"
          force-render
          v-if="enterpriseGlobalId != 'personal'"
        ></a-tab-pane>
      </a-tabs>
      <perfect-scrollbar class="term-content" v-if="filterData.length > 0">
        <a-radio-group v-model:value="libraryId" style="width: 100%">
          <div
            v-for="(item, key) in filterData"
            :key="key"
            class="flex-between term-item"
          >
            <a-radio
              :value="item.library_id"
              class="flex-1 white-1"
              style="max-width: 450px"
            >
              <span :title="item.library_name">{{ item.library_name }}</span>
            </a-radio>
            <div style="flex-basis: 80px; flex-shrink: 0; text-align: center">
              <span>{{ languageText(item) }}</span>
            </div>
            <div
              class="padding-5"
              v-if="item.library_id > -1"
              style="flex-basis: 80px; flex-shrink: 0; text-align: center"
            >
              <span>{{ item.count }}</span>
              <span class="margin-l-2">条</span>
            </div>
            <div
              class="color-7a59ff padding-5 margin-l-20"
              @click="checkFunc(item.library_id)"
              v-if="item.library_id > -1"
            >
              查看
            </div>
          </div>
        </a-radio-group>
      </perfect-scrollbar>
      <div
        v-else
        class="corpus-content text-center color-333 font-size-16 padding-tb-30"
      >
        暂无数据
      </div>
    </div>
    <div class="term-footer">
      <a-button @click="closeFunc" class="margin-r-10">取消</a-button>
      <a-button type="primary" @click="confirm">确定</a-button>
    </div>
  </a-modal>
</template>

<style lang="scss" scoped>
  ::v-deep(.ant-tabs-tab) {
    padding: 12px 0 !important;
  }
  ::v-deep(.ant-tabs-bar) {
    margin-bottom: 0;
  }
  .term-list-modal {
    .term-content {
      max-height: 250px;
      //padding-right: 10px;
      overflow-x: hidden;
      padding-bottom: 20px;
    }
    .term-item {
      height: 44px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      &:hover {
        background: #f8f7ff;
        //box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
      }
    }
    .term-footer {
      display: flex;
      justify-content: flex-end;
      height: 56px;
      padding-top: 12px;
      padding-right: 20px;
      background: #fff;
      box-shadow:
        0px 4px 20px 0px rgba(0, 0, 0, 0.1),
        inset 0px 1px 0px 0px #eee;
      border-radius: 0px 0px 8px 8px;
    }
  }
  .color-7a59ff {
    color: var(--primary-color);
  }
</style>
